var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6154 2.30769C23.6923 2.76923 22.7692 2.92308 21.6923 3.07692C22.7692 2.46154 23.5385 1.53846 23.8462 0.307692C22.9231 0.923077 21.8462 1.23077 20.6154 1.53846C19.6923 0.615385 18.3077 0 16.9231 0C13.6923 0 11.2308 3.07692 12 6.15385C7.84615 6 4.15385 4 1.53846 0.923078C0.153846 3.23077 0.923077 6.15385 3.07692 7.69231C2.30769 7.69231 1.53846 7.38462 0.769231 7.07692C0.769231 9.38462 2.46154 11.5385 4.76923 12.1538C4 12.3077 3.23077 12.4615 2.46154 12.3077C3.07692 14.3077 4.92308 15.8462 7.23077 15.8462C5.38461 17.2308 2.61538 18 0 17.6923C2.30769 19.0769 4.92308 20 7.69231 20C17.0769 20 22.3077 12.1538 22 4.92308C23.0769 4.30769 24 3.38462 24.6154 2.30769Z",
    fill: "#499BE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlue);
export default __webpack_public_path__ + "static/media/twitter-blue.3c03951167f84257b2974f6f23705695.svg";
export { ForwardRef as ReactComponent };